@let selectedItems = store.selectedItemsSg();
@let disabled = disabledSg();
@let expanded = store.expandedSg();
@let selectedCount = store.selectedCountSg();
@let label = store.labelSg() ?? '';
@let presentableLabel =
  selectedCount > 0 && label ? label + ' (' + selectedCount + ')' : label;
@let config = store.configSg();
@let showExpandButton = showExpandButtonSg();
@let isLoading = store.isLoadingSg();
@let error = store.presentableErrorSg();
@let placeholder = store.placeholderSg();

<div class="atn-ds-input-field">
  @if (presentableLabel) {
    <span
      class="atn-ds-input-field__label"
      data-test-id="atn-select-multi-label"
    >
      {{ presentableLabel }}
    </span>
  }
  <div
    class="ds-multi-select"
    [class.ds-multi-select--disabled]="disabled"
    [style.maxHeight.px]="config.expandedElMaxHeight"
    #overlayOrigin
  >
    <div
      [ngClass]="[
        store.expandedSg()
          ? 'ds-multi-select__items-expanded'
          : 'ds-multi-select__items',
      ]"
      #selectItemsContainerRef
      data-test-id="atn-select-multi"
      (click)="!disabled && toggleDropdownClickHandler()"
    >
      @for (selectedItem of selectedItems; track $index) {
        <div
          class="ds-multi-select__item"
          [class.ds-multi-select__item--disabled]="disabled"
          #selectedItemRef
        >
          <div
            class="ds-multi-select__item-label"
            data-test-id="atn-select-multi-input-selected-item-label"
          >
            {{ selectedItem.label }}
          </div>
        </div>
      } @empty {
        <span
          class="ds-multi-select__placeholder"
          data-test-id="atn-select-multi-input-placeholder"
          >{{ placeholder }}</span
        >
      }
    </div>
    @if (showExpandButton) {
      <div
        class="ds-multi-select__expander-button"
        (click)="toggleExpandButtonClickHandler()"
      >
        {{ expanded ? 'Hide' : 'Show' }}
      </div>
    }

    <div class="ds-multi-select__icons">
      @if (isLoading) {
        <i
          class="atn-icon atn-waiting atn-blue"
          data-test-id="atn-select-multi-loader"
        ></i>
      }
      <i
        class="fas fa-sort-down ds-multi-select__open-icon"
        [class.ds-multi-select__open-icon--disabled]="disabled"
        (click)="!disabled && toggleDropdownClickHandler()"
      ></i>
    </div>
  </div>
  <!-- ---------------------------- Error Banner ----------------------------- -->
  <!-- NOTE: Due to the structure of HTML, we cannot use if-else statements directly.
  Therefore, we should not display the error until loading is complete. -->
  @if (error && !isLoading) {
    <div
      class="ds-multi-select__error"
      data-test-id="atn-select-multi-error-banner"
    >
      <div class="ds-multi-select__error-info">
        <i class="atn-icon default atn-warning-triangle"></i>
        <span data-test-id="atn-select-multi-error-message">{{ error }}</span>
      </div>
      <div>
        @if (refetch.observed) {
          <i
            data-test-id="atn-select-multi-refetch-button"
            class="atn-icon atn-reset atn-dark"
            (click)="refetch.emit()"
          ></i>
        }
      </div>
    </div>
  }
</div>
<atn-ds-select-multiple-overlay [origin]="overlayOrigin" />
